<template>
  <div>
    <v-form ref="sendCode" onSubmit="return false" v-if="step===0" @submit="sendCode">
      <v-container class="pt-0">
        <v-layout column>
          <v-flex>
            <p class="headline">{{title[step]}}</p>
          </v-flex>
          <v-flex>
            <v-text-field
                v-model="userid"
                label="Email or Phone"
                :error="!!useridError"
                :error-messages="useridError"
            >
            </v-text-field>
          </v-flex>
          <v-flex class="text-sm-right">
            <v-btn
                round
                :loading="loading"
                color="warning"
                type="submit"
            >
              send code
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-form ref="resetPassword" onSubmit="return false" v-if="step===1" @submit="resetPassword">
      <v-container class="pt-0">
        <v-layout column>
          <v-flex>
            <p class="headline">{{title[step]}}</p>
          </v-flex>
          <v-flex>
            <v-text-field
                v-model="code"
                label="Password Reset Code"
            >
            </v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
                v-model="password"
                label="New Password"
                :append-icon="show ? 'visibility' : 'visibility_off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
            >
            </v-text-field>
          </v-flex>
          <div v-if="!!resetError">
            <v-alert :value="!!resetError" outline color="error" style="border-radius: 0.5rem;">
              {{resetError}}
            </v-alert>
          </div>
          <div v-else>
            <v-alert :value="!!resetSuccess" outline color="success" style="border-radius: 0.5rem;">
              {{resetSuccess}}
            </v-alert>
          </div>
          <v-flex class="text-sm-right">
            <v-btn
                round
                :loading="loading"
                color="warning"
                type="submit"
            >
              reset password
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
    import api from "../services/api/auth"
    import {mapMutations} from "vuex";

    export default {
        name: "ResetPassword",
        data() {
            return {
                step: 0,
                loading: false,
                title: ['Please enter your email or phone number', ''],
                userid: '',
                password: '',
                show: false,
                code: '',
                useridError: '',
                resetError: '',
                resetSuccess: ''
            }
        },
        computed: {
            mechanism() {
                return this.userid.includes("@") ? "email" : "phone"
            }
        },
        methods: {
            sendCode() {
                if (!this.userid) return
                let params = {
                    userid: this.userid,
                    mechanism: this.mechanism
                }
                this.loading = true
                api.getPsswdCode(params)
                    .then(resp => {
                        if (resp.Success) {
                            this.title[1] = resp.displayText
                            this.step = 1
                        } else {
                            if (resp.Error === -3013) {
                                this.useridError = `There is no user with id ${this.userid}.`
                            }
                        }
                        this.loading = false
                    }).catch(() => this.loading = false)
            },
            resetPassword() {
                if (!this.password || !this.code) return
                let params = {
                    code: this.code,
                    userid: this.userid,
                    password: this.password
                }
                this.loading = true
                api.resetPassword(params)
                    .then((resp) => {
                        if (resp.Success) {
                            this.resetSuccess = 'Your password has been reset successfully!'
                            this.$store.dispatch("auth/login", {
                                userid: this.userid,
                                password: this.password
                            }).then(() => {
                                if (this.$store.getters["auth/isSuccess"]) {
                                    this.$router.push("/home")
                                }
                                this.loading = false
                            }).catch(() => this.loading = false)
                        } else if (resp.Error) {
                            this.resetError = resp.Message
                            this.loading = false
                        }
                    }).catch(() => this.loading = false)
            }
        }
    }
</script>

<style scoped>

</style>
